import React from "react";
import ApprovalScope from "./ApprovalScope";
import hero4 from "../image/construction-bg1.png";
import hero6 from "../image/corporation-bg1.png";
import OtherServices from "../components/OtherServicesSlider";
import Footer from "../components/Footer";
import {
  FaDraftingCompass,
  FaHardHat,
  FaLayerGroup,
  FaBoxes,
  FaTools,
  FaPaintRoller,
  FaUsers,
  FaClipboardCheck
} from "react-icons/fa";

const constructionData = [
  {
    id: "01",
    icon: <FaDraftingCompass />,
    title: "Pre-Construction Planning",
    desc: "Understanding drawings, site preparation, layout marking, and coordination with design and structural teams before starting work.",
  },
  {
    id: "02",
    icon: <FaHardHat />,
    title: "Structural Execution",
    desc: "Foundation, RCC framework, reinforcement, and shuttering executed as per approved structural design.",
  },
  {
    id: "03",
    icon: <FaLayerGroup />,
    title: "Masonry & Basic Works",
    desc: "Brickwork/blockwork, internal partitions, and basic structural shaping of spaces.",
  },
  {
    id: "04",
    icon: <FaBoxes />,
    title: "Material Procurement & Management",
    desc: "Sourcing and managing quality materials from trusted vendors to ensure durability and consistency.",
  },
  {
    id: "05",
    icon: <FaTools />,
    title: "MEP & Service Works",
    desc: "Execution of electrical, plumbing, and other service lines integrated within the structure.",
  },
  {
    id: "06",
    icon: <FaPaintRoller />,
    title: "Finishing Works",
    desc: "Plastering, flooring, tiling, painting, and installation of doors, windows, and fixtures.",
  },
  {
    id: "07",
    icon: <FaUsers />,
    title: "Skilled Workforce & Execution Management",
    desc: "Deployment and supervision of trained labor and craftsmen to maintain quality standards.",
  },
  {
    id: "08",
    icon: <FaClipboardCheck />,
    title: "Site Supervision & Quality Monitoring",
    desc: "Regular monitoring, site coordination, and quality checks to ensure adherence to drawings and specifications.",
  },
];

export default function Construction({openContactModal, showCTA}) {
  return (

     <div>
    <ApprovalScope
      heroTitle={`Bungalow Construction & Execution`}
      heroSubtitle="Built with precision, quality control, and single point responsibility."
        heroImg={hero4}
         heroBg={hero6}

      sectionTitle="Bungalow Construction & Execution"

      topText="Dwellora delivers complete bungalow construction aligned precisely with architect intent. Through structured planning, certified materials, and continuous site supervision, we ensure each home is executed with durability, accuracy, and refined finish quality."

      heading="Detailed Construction Scope"

      data={constructionData}

      ctaTitle="The Dwellora Approach"
      ctaDesc="Because we design and build, there is no gap between drawings and execution. This ensures accuracy, accountability, and consistent quality throughout construction."

      ctaBtn="Let’s Consult"
        openContactModal={openContactModal}

    />

     <Footer 
  openContactModal={openContactModal}
  showCTA={showCTA} 
/>

    </div>
  );
}